import {useEnvironment} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React, {PropsWithChildren} from 'react'
import {TicketsListContainerProps} from './interfaces'
import s from './tickets-list-container.scss'

export const TicketsListContainer = ({
  children,
  className,
  basketView,
}: PropsWithChildren<TicketsListContainerProps>) => {
  const {isMobile} = useEnvironment()

  return (
    <ul
      className={classNames(s.list, className, {
        [s.basketViewDesktop]: basketView && !isMobile,
        [s.mobileList]: isMobile,
      })}
    >
      {children}
    </ul>
  )
}
